export class AddLabReportsRequest {

        "studyId": Number;
        "userId": Number;
        "patientId": String;
        "testName": String;
        "testValue": any;
        "fileURL": String;

}